import styled from "styled-components";

export const FooterWrapper = styled.div`
  width: 100%;
  height: 100px;
  background-color: ${(props) => props.theme.background_footer};
  padding: 8px 0px; 
  display: flex;
  align-items: center;
  margin-top: auto;
 

  
 
`;
export const FooterContainer = styled.div`
  width: 90%;
  margin: 0 auto;
`;
export const IconWrapper = styled.div`
  width: fit-content;
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
  svg {
    /* margin:0 10px; */
    @media screen and (max-width: 280px) {
      width: 35px;
      height: 35px;
    }
  }
`;
